export default __webpack_public_path__ + "static/gpsworldlogo-0518390dd096e6c8950ed3b7639c875c.png";